(() => {
  if (window.jdSelleasyPreorderBound) return;
  window.jdSelleasyPreorderBound = true;
  let purchase = null;
  function begin(event) {
    if (!event.isTrusted) return;
    const button = event.target.closest?.('button[type="submit"][name="add"]');
    const form = button?.form;
    if (!form) return;
    purchase = null;
    if (!form.querySelector('[name="selling_plan"]')?.value ||
        !form.querySelector('.lb-card-checkbox:checked')) return;
    if (button.disabled || button.getAttribute('aria-disabled') === 'true' ||
        form.closest('.jd-launch-pending')) return;
    const consent = form.querySelector('#restock-rocket-acknowledge-preorder');
    if (consent && !consent.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      consent.focus();
      return;
    }
    purchase = {requests: new Map()};
  }
  window.addEventListener('click', begin, true);
  const previousFetch = window.fetch;
  window.fetch = function (input, options) {
    let url;
    try { url = new URL(typeof input === 'string' ? input : input?.url, location.href); } catch {}
    const addon = purchase && url?.origin === location.origin &&
      /\/cart\/add(?:\.js)?$/.test(url.pathname) && url.searchParams.get('src') === 'selleasy' &&
      options?.method?.toUpperCase() === 'POST' && typeof options.body === 'string';
    if (!addon) return previousFetch.apply(this, arguments);
    // Some cart/preorder app combinations emit the same Selleasy request twice
    // for one click. Share that response; a new customer click starts a new cycle.
    const key = url.href + '\n' + options.body;
    let response = purchase.requests.get(key);
    if (!response) {
      response = previousFetch.apply(this, arguments);
      purchase.requests.set(key, response);
    }
    return response.then(result => result.clone());
  };
})();
